module.exports = __webpack_public_path__ + "img/top2.fe569e6e.png";